module.exports = __webpack_public_path__ + "img/icon-export-pdf-blue.d1162ea0.svg";